<div class="row mt-5">
    <div class="col-offset-3 col-6">
        <p class="alert alert-dark">Vous n'êtes pas authentifié.</p>
        <p>Veuillez <a href="#" (click)="login($event)">cliquer sur ce lien</a> afin de poursuivre.</p>
    </div>
</div>